export const hasItems = function ({ fields }: { fields: any }) {
  if (!fields) {
    return false;
  }

  return true;
};
